import {
  assign,
  toUpper,
  each,
  toLower,
  has,
  isNil,
  keys,
  map,
} from 'lodash';
import taxService from '@nsftx/seven-gravity-tax-service';
import { formatter } from '@/utility';

const BETS = ['black', 'red', 'even', 'odd', 'firstDozen', 'secondDozen', 'thirdDozen'];


export default {
  allowedShortcutChars: state => state.allowedShortcutChars,
  betMap: state => state.betMap,
  betShortcuts: state => state.betShortcuts,
  channel: state => toLower(state.platform.channel),
  channelSettings: (state, getters) => {
    const channel = getters.platformChannel.toLowerCase();
    const settings = getters.config.gateway.settings[channel];
    const { wheelBets } = getters;
    const { wheelTickets } = getters;
    const payinTaxPolicyConfig = taxService.policies[wheelTickets.ticketPayinTaxPolicy] || null;
    const payoutTaxPolicyConfig = taxService.policies[wheelTickets.ticketPayoutTaxPolicy] || null;
    const { bets } = getters.config.wheel.definition;
    const translatedShortcuts = {};
    const betsConfiguration = keys(bets);

    each(betsConfiguration, (betName) => {
      // eslint-disable-next-line;
      const bet = bets[betName];
      const hasDescription = ['basket'];
      if (BETS.indexOf(bet.name) < 0) return;
      const title = wheelBets[bet.name] ? wheelBets[bet.name].title : state.translations[bet.name];
      const shortcutKey = toUpper(bet.shortcut.name);
      const description = hasDescription.indexOf(bet.name) > -1 ? ` (${formatter.numberFormatter(bet.values)})` : '';
      const modifiedShortcut = {
        name: title,
        // eslint-disable-next-line
        shortcut: shortcutKey,
      };
      translatedShortcuts[shortcutKey] = assign({}, modifiedShortcut, {
        action: 'Standard',
        active: true,
        name: `${title}${description}`,
      });
    });
    // eslint-disable-next-line
    translatedShortcuts['Q'] = {
      // eslint-disable-next-line
      name: state.translations['results'] || 'Results',
      shortcut: 'Q',
      active: true,
    };

    return {
      ticketConfig: settings.ticketConfig,
      shortcuts: translatedShortcuts,
      tax: {
        payin: {
          hideTax: isNil(payinTaxPolicyConfig) || toLower(payinTaxPolicyConfig.payer) === 'company',
          policy: wheelTickets.ticketPayinTaxPolicy || '',
          value: has(taxService.policies, wheelTickets.ticketPayinTaxPolicy),
        },
        payout: {
          hideTax: isNil(payinTaxPolicyConfig) || toLower(payoutTaxPolicyConfig.payer) === 'company',
          policy: wheelTickets.ticketPayoutTaxPolicy || '',
          value: has(taxService.policies, wheelTickets.ticketPayoutTaxPolicy),
        },
      },
    };
  },
  eventRound: (state, getters) => (status) => {
    let eventRound = null;
    const { nextRounds, round } = getters;
    if (round.status.name === 'open') {
      eventRound = status === 'id' ? round.id : round.displayId;
    } else if (nextRounds.length) {
      eventRound = status === 'id' ? nextRounds[0].id : nextRounds[0].displayId;
    }
    return eventRound;
  },
  betslip: state => state.betslip,
  config: state => state.config,
  isRoundInProgress: (state, getters) => {
    const { roundEvent } = getters;
    const roundEvents = ['countdown', 'bettingDisabled'];
    return roundEvent && roundEvents.indexOf(roundEvent.name) < 0;
  },
  isBettingDisabled: (state, getters) => {
    const { roundEvent } = getters;
    return roundEvent && roundEvent.name === 'bettingDisabled';
  },
  isRetail: (state, getters) => (getters.channel === 'shop'),
  multiStraightSeparator: (state, getters) => getters.allowedShortcutChars[0],
  nextRound: (state, getters) => {
    if (getters.round) {
      return {
        displayId: getters.round.displayId + 1,
      };
    }

    return getters.round;
  },
  limits: state => state.limits,
  nextRounds: state => state.nextRounds,
  platform: state => state.platform,
  platformChannel: state => state.platform.channel,
  route: state => state.route,
  round: state => state.round,
  updateBet: state => state.updateBet,
  shortcuts: state => state.config.shortcuts,
  socketProvider: state => state.socketProvider,
  parseTicketBets: getters => (bets, isRebet) => map(bets, (n) => {
    const bet = {
      name: n.name,
      values: n.values ? n.values
        : map(n.betSelection, value => (value === '00' ? -1 : value)),
      selection: [],
      label: n.label,
      title: n.title ? n.title : n.displayName,
      displayValue: n.displayValue,
      numbers: n.numbers ? n.numbers : n.betSelection.length,
      numberOfRounds: n.numberOfRounds ? n.numberOfRounds : 1,
      odds: Number(n.odds),
      payment: n.payment ? Number(n.payment) : Number(n.paymentAmount),
    };

    bet.selection = map(bet.values, value => ({ number: value }));

    if (isRebet && bet.payment < getters.limits.bet.ticketBetMinPayment) {
      bet.payment = getters.limits.bet.ticketBetMinPayment;
    }
    return bet;
  }),
  roundEvent: (state, getters) => (getters.round ? getters.round.event : null),
  roundEventDuration: (state, getters) => {
    if (getters.roundEvent && getters.wheel) {
      const wheelEvent = getters.wheel.definition.events[getters.roundEvent.name];
      return wheelEvent.duration;
    }

    return null;
  },
  roundEventStart: (state, getters) => (getters.roundEvent ? getters.roundEvent.createdAt : null),
  roundStatus: (state, getters) => (getters.round ? getters.round.status : null),
  ticketConfiguration: (state, getters) => {
    const config = {
      config: getters.betslip.tickets[0],
      creationType: getters.creationType,
      round: {
        id: getters.eventRound('id'),
        displayId: getters.eventRound('displayId'),
      },
    };
    return config;
  },
  ticket: state => state.ticket,
  ticketBets: state => state.ticket.bets,
  translation: state => key => state.translations[key],
  translations: state => state.translations,
  user: state => state.user,
  ui: state => state.ui,
  wheel: (state, getters) => getters.config.wheel,
  wheelBets: (state, getters) => getters.wheel.definition.bets,
  wheelTickets: (state, getters) => getters.wheel.definition.tickets,
};
